import { cn } from "@-/com.npmjs.cn";
import { View, useWindowDimensions } from "@-/com.npmjs.react-native";
import { getSurfaceGridLayout } from "@-/dev.improve.haniverse.components.ui.surface";
import { useHasHydrated } from "@-/dev.improve.haniverse.lib.hydration";
import { useState } from "react";
import {
  SkeletonGroup,
  SkeletonTileSurface,
} from "@-/dev.improve.haniverse.components.ui.skeleton";

/** Matches the header and square character rows of a level surface while its data loads. */
export function LevelSurfaceSkeleton({ columns = 8 }: { columns?: number }) {
  return <SkeletonTileSurface columns={columns} />;
}

/** Shared empty-list content; the owning list supplies its normal padding and column count. */
export function LevelSurfacesSkeleton({
  className,
  columns,
}: {
  className?: string;
  columns?: number;
}) {
  const { height, width } = useWindowDimensions();
  const [layoutWidth, setLayoutWidth] = useState(0);
  // Web server rendering has no window, so the server and hydrating renders show full-width
  // surfaces; the window estimate (and then the measured width) applies once hydrated.
  const hasHydrated = useHasHydrated();
  const layout = hasHydrated
    ? getSurfaceGridLayout(layoutWidth || Math.min(width, height) - 8)
    : { glyphColumns: undefined, surfaceWidth: "100%" as const };
  return (
    <SkeletonGroup
      accessibilityLabel="Loading level surfaces"
      className={cn("flex-row flex-wrap items-start gap-1", className)}
      onLayout={(event) => setLayoutWidth(event.nativeEvent.layout.width)}
      testID="level-surfaces-skeleton"
    >
      {[0, 1, 2, 3].map((surface) => (
        <View key={surface} style={{ width: layout.surfaceWidth }}>
          <LevelSurfaceSkeleton columns={columns ?? layout.glyphColumns} />
        </View>
      ))}
    </SkeletonGroup>
  );
}
